import type { JSX } from "react";

import { Select } from "@mantine/core";

import { isChatTask, isVoiceTask, useMostRecentTask } from "@/sdk";

import { GrayWorld } from "./icons/GrayWorld";
import { abbreviations, useLanguageStore } from "./useLanguageStore";

export function LanguageSelector(): JSX.Element | null {
    const { abbreviation, updateLanguage } = useLanguageStore();
    const task = useMostRecentTask();

    if (!isVoiceTask(task) && !isChatTask(task)) {
        return null;
    }

    // Ensure the locale matches for supported tasks
    if (task.locale !== "es-mx") {
        return null;
    }

    return (
        <Select
            data-testid="language-selector"
            data={abbreviations}
            value={abbreviation}
            onChange={updateLanguage}
            allowDeselect={false}
            withCheckIcon={false}
            comboboxProps={{ withinPortal: false }}
            leftSection={<GrayWorld />}
            maw={90}
            fz="xs"
            size="xs"
            styles={{
                input: {
                    fontSize: 12,
                },
            }}
        />
    );
}
